import { combineReducers } from "redux";

import annotations from "./annotations";
import content from "./content";
import header from "./header";
import marginalLayer from "./marginalLayer";
import materialLayer from "./materialLayer";
import menu from "./menu";
import modal from "./modal";
import sidebarLeft from "./sidebarLeft";
import sidebarRight from "./sidebarRight";
import dls from "./dls";
import embedded from "./embedded";
import notes from "./notes";

// UI Reducer
export default combineReducers({
  annotations,
  content,
  header,
  marginalLayer,
  materialLayer,
  menu,
  modal,
  sidebarLeft,
  sidebarRight,
  dls,
  embedded,
  notes
});
